import { render } from "./SystemView.vue?vue&type=template&id=9c6327c4&scoped=true&ts=true"
import script from "./SystemView.vue?vue&type=script&lang=ts"
export * from "./SystemView.vue?vue&type=script&lang=ts"

import "./SystemView.vue?vue&type=style&index=0&id=9c6327c4&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6327c4"]])

export default __exports__